<template>
  <div class="col-12 col-sm-6">
    <fg-input :label="$t('generic.jobBoard')"
              :error="getError($t('generic.jobBoard'))"
              required>
      <JobBoardsForProductAutocomplete :product-id="form.job.product_id"
                                       :name="$t('generic.jobBoard')"
                                       multiple
                                       value-key="id"
                                       option-key="job_board"
                                       v-validate="'required'"
                                       v-model="form.job.job_boards">
      </JobBoardsForProductAutocomplete>
    </fg-input>
  </div>
</template>
<script>
  import JobBoardsForProductAutocomplete from 'src/components/Autocomplete/JobBoardsForProductAutocomplete'
  export default {
    name: 'job-select-job-boards',
    components: {
      JobBoardsForProductAutocomplete
    },
    props: {
      form: {
        type: Object,
        default: () => {
          return {
            job: {
              product_id: '',
              job_boards: []
            }
          }
        }
      }
    },
    methods: {
      validate() {
        return this.$validator.validateAll()
      }
    },
    watch: {
      'form.job.job_boards'(value) {
        if (!Array.isArray(value)) {
          this.form.job.job_boards = [value]
        }
      }
    }
  }
</script>
<style>
</style>
